// Dependencies
import axios from 'axios';
import { useDispatch } from 'react-redux';

// Variables
const baseURL = process.env.REACT_APP_API_URL;

// Dashboard API hook
export default function useUserApi() {

	// State and hooks
	const dispatch = useDispatch();

	// Get user types
	const verifyJWT = async () => {

		// Request
		const response = await axios.get(`${baseURL}/admin/auth/verify_jwt`, {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('webikecc_jwt'),
			}
		});

		// Assign and return
		dispatch.authData.setRole(response.data.data.role);
		dispatch.authData.setTenant(response.data.data.tenant);
		return;

	}

	// Return
	return { verifyJWT };

}
